import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  createHusbandryTask,
  deleteHusbandryTask,
  fetchHusbandryQuickTasks,
  fetchHusbandryTasks,
  updateHusbandryTask,
  updateHusbandryTaskStatus,
} from "../../apis/husbandryTasks";

import type {
  CreateHusbandryTaskPayload,
  HusbandryQuickTask,
  HusbandryTask,
  HusbandryTaskStatus,
  UpdateHusbandryTaskPayload,
} from "../../utils/types/husbandryTasks";

export const fetchHusbandryTasksThunk = createAsyncThunk<
  { data: HusbandryTask[]; total: number },
  | { search?: string; agentId?: string; vesselStatus?: string; jobId?: string }
  | undefined,
  { rejectValue: string }
>("husbandryTasks/fetchTasks", async (params, { rejectWithValue }) => {
  try {
    const response = await fetchHusbandryTasks(params);
    return response;
  } catch (error: any) {
    return rejectWithValue(error.message || "Failed to fetch husbandry tasks");
  }
});

export const createHusbandryTaskThunk = createAsyncThunk<
  HusbandryTask,
  CreateHusbandryTaskPayload,
  { rejectValue: string }
>("husbandryTasks/createTask", async (task, { rejectWithValue }) => {
  try {
    const response = await createHusbandryTask(task);
    return response;
  } catch (error: any) {
    return rejectWithValue(error.message || "Failed to create husbandry task");
  }
});

export const updateHusbandryTaskThunk = createAsyncThunk<
  HusbandryTask,
  UpdateHusbandryTaskPayload,
  { rejectValue: string }
>("husbandryTasks/updateTask", async (task, { rejectWithValue }) => {
  try {
    const response = await updateHusbandryTask(task);
    return response;
  } catch (error: any) {
    return rejectWithValue(error.message || "Failed to update husbandry task");
  }
});

export const updateHusbandryTaskStatusThunk = createAsyncThunk<
  HusbandryTask,
  { taskId: string; status: HusbandryTaskStatus },
  { rejectValue: string }
>("husbandryTasks/updateTaskStatus", async ({ taskId, status }, { rejectWithValue }) => {
  try {
    const response = await updateHusbandryTaskStatus(taskId, status);
    return response;
  } catch (error: any) {
    return rejectWithValue(error.message || "Failed to update husbandry task status");
  }
});

export const deleteHusbandryTaskThunk = createAsyncThunk<
  string,
  string,
  { rejectValue: string }
>("husbandryTasks/deleteTask", async (taskId, { rejectWithValue }) => {
  try {
    await deleteHusbandryTask(taskId);
    return taskId;
  } catch (error: any) {
    return rejectWithValue(error.message || "Failed to delete husbandry task");
  }
});

export const fetchHusbandryQuickTaskThunk = createAsyncThunk<
  { data: HusbandryQuickTask[] }
>("husbandryTasks/fetchQuickTasks", async (_, { rejectWithValue }) => {
  try {
    const result = await fetchHusbandryQuickTasks();
    return { data: result };
  } catch (error: any) {
    return rejectWithValue(error.message || "Failed to fetch quick tasks");
  }
});
